import handleError from '/chat/src/lib/FetchErrorHandling'
import store from '/chat/src/redux/store';

class Feedback {
    sendFeedback(systemType, systemId, feedback, rating, cb) {
        //rating == {-1, 1} only accepted at the moment.
        const state = store.getState()
        const apiStub = state.getIn(['config', 'backendApiUrl']);
        const token = state.getIn(['user', 'token'])
        const url = `${apiStub}/v2/feedback/create`;
        return fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'system_type': systemType,
                'system_id': systemId,
                'feedback': feedback,
                'rating': rating
            }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }).then( (res) => handleError(res) )
        .then( payload => cb(payload, '200') )
        .catch( error => cb(error, error.statusText))
    }
}

export default new Feedback();



// WEBPACK FOOTER //
// ./redux/model/feedback/model.js